// test2542
(2542 && 0);
